import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Contexts
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Menu from './components/Menu';
import CartDrawer from './components/CartDrawer';
import DeliverySection from './components/DeliverySection';
import LoyaltySection from './components/LoyaltySection';
import InstagramFeed from './components/InstagramFeed';

// Pages
import AdminDashboard from './pages/AdminDashboard';
import Account from './pages/Account';
import Contact from './pages/Contact';

// Styles
import './App.css';

// Customer Home Page
const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Hero />
      <Menu />
      <DeliverySection />
      <LoyaltySection />
      <InstagramFeed />

      {/* Featured info section */}
      <section className="features-section">
        <div className="container features-grid">
          <motion.div className="feature-card">
            <span className="feature-icon">🥩</span>
            <h3 className="feature-title">Qualité Premium</h3>
            <p className="feature-text">Viande 100% française et pain buns artisanal préparé chaque matin par notre boulanger.</p>
          </motion.div>
          <motion.div className="feature-card">
            <span className="feature-icon">🍟</span>
            <h3 className="feature-title">Fait Maison</h3>
            <p className="feature-text">Toutes nos frites sont coupées à la main et cuites en deux temps pour un croustillant légendaire.</p>
          </motion.div>
          <motion.div className="feature-card">
            <span className="feature-icon">🚲</span>
            <h3 className="feature-title">Click & Collect</h3>
            <p className="feature-text">Commandez en ligne et récupérez votre commande sans attendre une seconde.</p>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <span className="footer-logo-badge">SH</span>
            SUGAR HUT
          </Link>
          <p className="footer-description">
            L'art du burger gourmet à Montesson. Des produits frais, du goût, et beaucoup d'amour dans chaque bouchée.
          </p>
          <div className="footer-socials">
            <div className="social-icon">IG</div>
            <div className="social-icon">FB</div>
          </div>
        </div>

        <div>
          <h4 className="footer-heading">Navigation</h4>
          <ul className="footer-nav-list">
            <li><Link to="/" className="footer-nav-link">Notre Carte</Link></li>
            <li><Link to="/contact" className="footer-nav-link">Localisation</Link></li>
            <li><Link to="/admin" className="footer-nav-link">Espace Admin</Link></li>
          </ul>
        </div>

        <div className="footer-contact-info">
          <h4 className="footer-heading">Contact</h4>
          <p>65 bis Avenue Paul Doumer</p>
          <p>78360 Montesson</p>
          <span className="footer-phone">01 23 45 67 89</span>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 Sugar Hut. Design with ❤️ by Antigravity AI.
      </div>
    </div>
  </footer>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <FavoritesProvider>
          <CartProvider>
            <div className="min-h-screen relative overflow-x-hidden">
              <Navbar />
              <CartDrawer />
              <AnimatePresence mode="wait">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/admin/*" element={<AdminDashboard />} />
                </Routes>
              </AnimatePresence>
              <Footer />
            </div>
          </CartProvider>
        </FavoritesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
